/* Hype pages — stat counters. Copy fades up, then the numbers count. */

(function () {
  function animateNumber(element, timeline, label) {
    var target = parseFloat(element.getAttribute("data-hype-counter-to"));
    if (isNaN(target)) return;

    var raw = element.getAttribute("data-hype-counter-to") || "";
    var decimalPart = raw.split(".")[1];
    var decimals = decimalPart ? decimalPart.length : 0;
    var suffix = element.getAttribute("data-hype-counter-suffix") || "";
    var duration = parseFloat(element.getAttribute("data-hype-counter-duration")) || 1;

    timeline.add(
      gsap.to(element, {
        innerText: target,
        duration: duration,
        snap: { innerText: decimals > 0 ? Math.pow(10, -decimals) : 1 },
        onUpdate: function () {
          var node = this.targets()[0];
          var value = decimals > 0
            ? parseFloat(node.innerText).toFixed(decimals)
            : Math.round(parseFloat(node.innerText));
          node.innerHTML = suffix
            ? value + '<span class="hype-counter-suffix">' + suffix + "</span>"
            : String(value);
        }
      }),
      label
    );
  }

  function initSection(section) {
    if (section.dataset.hypeCountersReady === "true") return;
    section.dataset.hypeCountersReady = "true";

    window.HypeCore.ready(function (core) {
      /* No GSAP on this template: reveal with the core fallback and show the
         numbers at their final values rather than counting to them. */
      if (typeof gsap === "undefined") {
        core.reveal(section, { start: "top 50%", stagger: 0.1 });
        section.querySelectorAll(".hype-counter").forEach(function (counter) {
          var suffix = counter.getAttribute("data-hype-counter-suffix") || "";
          counter.innerHTML =
            (counter.getAttribute("data-hype-counter-to") || "") +
            (suffix ? '<span class="hype-counter-suffix">' + suffix + "</span>" : "");
        });
        section.querySelectorAll(".hype-plus-sign").forEach(function (plus) {
          plus.style.opacity = "1";
        });
        return;
      }

      var items = section.querySelectorAll("[data-hype-reveal-item]");
      gsap.set(items, { opacity: 0, y: 50 });

      var tl = gsap.timeline({
        scrollTrigger: { trigger: section, start: "top 50%", once: true }
      });

      tl.to(items, { opacity: 1, y: 0, duration: 0.5, stagger: 0.1 }).addLabel(
        "startCounting",
        "-=0.2"
      );

      section.querySelectorAll(".hype-counter").forEach(function (counter) {
        animateNumber(counter, tl, "startCounting");
      });

      section.querySelectorAll(".hype-plus-sign").forEach(function (plus) {
        tl.to(plus, { opacity: 1, duration: 0.5 }, "startCounting");
      });
    });
  }

  function init() {
    if (!window.HypeCore) return;
    document.querySelectorAll(".hype-stat-counters").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
